import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { useFormik } from "formik";
import ReusableForm from "./AddOnCard";
import { fetchaddOnsByCalendarOrganisation } from "../Services/Organisation.service";
import { useTranslation } from "react-i18next";
import { arrayBufferToBase64 } from "../utils";

interface FormValues {
  addons: Array<any>;
}

interface AddonsFormProps {
  organisationid: string;
  calendarObject: any;
  setActiveStep: any;
  activeStep: number;
  setNavigationDirection: any;
  navigationDirection: any;
  setFieldValue: any
}

const AddonsForm = forwardRef((props: AddonsFormProps, ref) => {
  const { organisationid, calendarObject, setActiveStep, navigationDirection, setFieldValue } = props;
  const [addonsList, setAddonsList] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  useEffect(() => {
    if (organisationid && calendarObject) {
      fetchaddOnsByCalendarOrganisation(organisationid, calendarObject?.calendarid)
        .then((res) => {
          setAddonsList(res.data);
          if(res.data.length === 0 && navigationDirection === 'forward') {
            setActiveStep((pre: number) => { return 3})
          }

          if(res.data.length === 0 && navigationDirection === 'backward') {
            setActiveStep((pre: number) => { return 1 })
          }
        })
        .finally(() => setLoading(false));
    }
  }, [organisationid, calendarObject]);

  const initialValues: FormValues = {
    addons: [],
  };

  const formik = useFormik({
    initialValues,
    onSubmit: (values) => {
      console.log(values);
    },
  });

  // Expose formik values and handleSubmit to the parent component
  useImperativeHandle(ref, () => ({
    getFormData: () => formik.values,
  }));

  return (
    <>
      {!loading ? (
        addonsList.length > 0 &&
        addonsList.map((addonData: any, index: number) => {
          return (
            <ReusableForm
              title={addonData?.calendarname}
              description={addonData?.description}
              imageUrl={addonData?.image ? arrayBufferToBase64(addonData?.image) : 'https://www.filepicker.io/api/file/Ofk2FoClQtOxtacCjMOY'}
              formik={formik}
              addonObject={addonData}
              formItems={addonData?.prices}
              timeOptions={addonData?.timeslots}
              key={index}
              setFieldValue={setFieldValue}
            />
          );
        })
      ) : (
        <>{t("Loading")}</>
      )}
    </>
  );
});

export default AddonsForm;
